"use client"

// SKU picker — searches `shopify_product_variants` by SKU substring with
// server-side ILIKE. Debounced 250ms per keystroke; `has_more=true` surfaces
// a "narrow your search" hint. See `NetworkPicker` for the shared shell.

import { NetworkPicker } from "./network-picker"

export interface SkuPickerProps {
  integrationId: string
  value: string
  onChange: (ref: string) => void
  disabled?: boolean
  triggerTestId?: string
}

export function SkuPicker({
  integrationId,
  value,
  onChange,
  disabled,
  triggerTestId,
}: SkuPickerProps) {
  return (
    <NetworkPicker
      endpoint="/api/integrations/shopify/bundles/components/sku"
      mode="remote"
      integrationId={integrationId}
      value={value}
      onChange={onChange}
      placeholder="Pick a variant SKU…"
      searchPlaceholder="Search SKUs…"
      emptyMessage="No matching SKUs."
      disabled={disabled}
      triggerTestId={triggerTestId}
    />
  )
}
